import { AutoComplete, Button, FormInput } from "@4uhub/lib4uhub";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { hexToRgbA } from "../../../utils/utils";
import { ITotemStartFormProps } from "./models";
import { PasswordField } from "./PasswordField/PasswordField";

const translationPath = "page.totem_start.";

export const TotemStartForm = memo(
  ({ environmentOptions, colors }: ITotemStartFormProps) => {
    const { t } = useTranslation();

    return (
      <>
        <AutoComplete
          name="environment"
          label={t(translationPath + "environment")}
          getOptionLabel={(option) => option.name}
          options={environmentOptions}
          clearIcon={false}
          fullWidth
          renderOption={(props, option, state) => {
            return (
              <li
                {...props}
                style={{
                  ...props.style,
                  ...(state.selected ? { backgroundColor: colors.light } : {}),
                }}
              >
                {option.name}
              </li>
            );
          }}
          sx={{
            "& label.Mui-focused": {
              color: colors.secondary,
            },
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: colors.secondary,
              },
            },
          }}
        />

        <FormInput
          name="code"
          margin="normal"
          label={t(translationPath + "code")}
          fullWidth
          sx={{
            "& label.Mui-focused": {
              color: colors.secondary,
            },
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: colors.secondary,
              },
            },
          }}
        />

        <PasswordField colors={colors} />

        <Button
          variant="contained"
          type="submit"
          fullWidth
          sx={{
            marginTop: 2,
            padding: 1.5,
            fontSize: 18,
            fontWeight: "bold",
            color: "white",
            background: `linear-gradient(135deg, ${colors.primary}, ${colors.secondary})`,
            boxShadow: "none",
            transition: "all .5s ease-out",
            "&:hover": {
              boxShadow: `0px 0px 30px 0px ${hexToRgbA(colors.secondary, 0.5)}`,
            },
          }}
        >
          {t(translationPath + "enter")}
        </Button>
      </>
    );
  }
);
